import { FormEntryField } from '../../../core/type'
import { Checkbox } from 'antd'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { confirm, translate } from '../../../core'

export type OrderFormRepairCheckBoxProps = FormEntryField<boolean> & {
  disabled?: boolean
}

export const OrderFormRepairCheckBox = ({onChange, checked, disabled}: OrderFormRepairCheckBoxProps) => {
  const handleChange = async (e: CheckboxChangeEvent) => {
    const {checked: updatedChecked} = e.target

    if(!e.target.checked) {
      const result = await confirm(
        translate('removing_repair_confirmation')
      )

      if(!result)
        return
    }

    onChange!(updatedChecked)
  }

  return (
    <Checkbox
      disabled={disabled}
      checked={checked}
      onChange={handleChange}
    />
  )
}